import React, { useEffect, useState } from "react";
import { IFadeBackgroundWrapperProps } from "./FadeBackgroundWrapper.interfaces";
import { rgbToRgba } from "../../../Color/utils/rgbToRgba";
import { useCreatorThemeContext } from "../../../Theme/CreatorThemeContext";
import { getColorsFromCreatorTheme } from "../../../Theme/utils/Theme.utils";

const FadeBackgroundWrapper: React.FC<IFadeBackgroundWrapperProps> = ({
  children,
  className,
  enableFade = true,
  boxShadow = "0px 0px 0px 10px",
  Component = "div",
}): React.ReactNode => {
  const theme = useCreatorThemeContext();
  const { color1 } = getColorsFromCreatorTheme(theme);

  const initialBackgroundColor = rgbToRgba(color1, "0.15") || "#F8F2FF";
  const finalBackgroundColor = "#ffffff";
  const initialBoxShadow = `${initialBackgroundColor} ${boxShadow}`; // Initial box shadow color
  const finalBoxShadow = `${finalBackgroundColor} ${boxShadow}`; // Final box shadow color

  const [fadeStyle, setFadeStyle] = useState({
    backgroundColor: initialBackgroundColor,
    boxShadow: initialBoxShadow,
  });

  useEffect(() => {
    if (enableFade) {
      // Start a timeout for fading
      const timeoutId = setTimeout(() => {
        // Change to the fade-out color and box shadow
        setFadeStyle({
          backgroundColor: finalBackgroundColor,
          boxShadow: finalBoxShadow,
        });
      }, 3000); // Delay of 3 seconds

      return () => clearTimeout(timeoutId); // Cleanup timeout
    }
  }, [enableFade]);

  return (
    <Component
      style={{
        ...fadeStyle,
        transition: "background-color 1s, box-shadow 1s",
        borderRadius: "1px", // Transition for both background and box shadow
      }}
      className={className}
    >
      {children}
    </Component>
  );
};

export default FadeBackgroundWrapper;
